var $ff5119b6bd47ddc8$exports = {};
$ff5119b6bd47ddc8$exports = {
    "loading": `Laden...`,
    "placeholder": `Ausw\xe4hlen\u{2026}`
};


export {$ff5119b6bd47ddc8$exports as default};
//# sourceMappingURL=de-DE.mjs.map
